require('./mortgageRequestOperativeGeneralDataView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { formatCurrency } = require('utilities/currencyHelper');
// @ components
const { MortgageRequestOperativeGeneralData } = require('components/mortgageRequest/mortgageRequestOperativeGeneralData/mortgageRequestOperativeGeneralData');
const { MortgageRequestOperativeParticipants } = require('components/mortgageRequest/mortgageRequestOperativeParticipants/mortgageRequestOperativeParticipants');
// @ constants
const { GENERAL_DATA } = require('constants/mortgageRequestMortgageDataTypes');
// @ actions
const getOperativeGeneralDataAction = require('actions/mortgageRequest/mortgageRequestOperativeGeneralData');

class MortgageRequestOperativeGeneralDataView extends React.Component {

    constructor(props) {
        super(props);

        this.currency = GENERAL_DATA.CURRENCY;
        this.product = GENERAL_DATA.PRODUCT_NUMBER;
        this.organization = GENERAL_DATA.ORGANIZATION;
        this.operation = GENERAL_DATA.OPERATION;
    }

    componentWillMount() {
        const { immLoans, requestOperativeGeneralDataAmortization } = this.props;
        const { YEAR, MONTH, DAY } = GENERAL_DATA.FUTURE_DATE;

        const sinceDate = new Date().toISOString().slice(0, 10);
        const untilDate = new Date(YEAR, MONTH, DAY).toISOString().slice(0, 10);

        const loan = immLoans.get('byId').filter(
            obj => obj.get('product') === this.product
        ).first();

        this.contractNumber = (loan) ? loan.get('contractNumber') : 0;

        requestOperativeGeneralDataAmortization(this.currency, this.product, this.contractNumber, this.organization, sinceDate, untilDate, this.operation);
    }

    render() {
        let content;
        const { operativeGeneralDataAmortization, immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestOperativeGeneralData-mortgage'),
                url: '/myprofile/mortgage'
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        const data = (text1, text2, currency) => {
            const currencyFormatted = formatCurrency(currency);

            return (
                <div className="mortgage-request-operative-general-data-view__description">
                    <div className="mortgage-request-operative-general-data-view__value">
                        <span>{text1} </span>
                        <span>{currencyFormatted}</span>
                    </div>
                    <div className="mortgage-request-operative-general-data-view__label">
                        <span>{text2}</span>
                    </div>
                </div>
            )
        };

        const values = () => {
            let amortizationList = operativeGeneralDataAmortization.get('listaAmortPrestamo', []).toJS();

            return (
                <div>

                    {(amortizationList.length > 0) ? data(amortizationList[0].installment.amount,
                        formatText('mortgageRequestOperativeGeneralData-feeAmmount'),
                        amortizationList[0].installment.currency) : null}

                    {(amortizationList.length > 0) ? data(amortizationList[0].pendingCapital.amount,
                        formatText('mortgageRequestOperativeGeneralData-pendingCapital'),
                        amortizationList[0].pendingCapital.currency) : null}

                </div>
            );
        };

        if (operativeGeneralDataAmortization.get('isFetching')) {
            content = <LoadingSection />
        } else {
            content = (
                <div className="mortgage-request-operative-general-data-view">
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    finalTitle={getFinalTitle('mortgageRequestPresentation-title')}
                                    children={values()}
                                />
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-8">
                                    <ContentBox>
                                        <MortgageRequestOperativeGeneralData product={this.product} contractNumber={this.contractNumber} />
                                        <MortgageRequestOperativeParticipants product={this.product} contractNumber={this.contractNumber} />
                                    </ContentBox>
                                </div>
                                <div className="mortgage-request-operative-general-data-view__commercial-ads col-xs-4">
                                    <CommercialAds path="operative-general-data" type="cross-selling" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }
}


MortgageRequestOperativeGeneralDataView.propTypes = {
    immLoans: PropTypes.object,
    operativeGeneralDataAmortization: PropTypes.object,
    requestOperativeGeneralDataAmortization: PropTypes.func,
    immGlobalPosition: PropTypes.object.isRequired
};

module.exports.constructor = MortgageRequestOperativeGeneralDataView;
module.exports.MortgageRequestOperativeGeneralDataView = connect(
    state => ({
        immLoans: state.loans,
        operativeGeneralDataAmortization: state.mortgageRequestOperativeGeneralDataAmortization,
        immGlobalPosition: state.globalPosition,
    }), {
    requestOperativeGeneralDataAmortization: getOperativeGeneralDataAction.requestOperativeGeneralDataAmortization
}
)(MortgageRequestOperativeGeneralDataView);
